import type { TFunction } from 'i18next';

/**
 * The label keys the group policy detail export names (SDD-020 §8.3, prompt 28 Decision 6). The
 * service publishes the same list in api/exports/; a unit test fails when they differ, and the
 * typed `t` fails the build when a key has no text.
 */
export const GROUP_POLICY_EXPORT_LABEL_KEYS = [
  'column.field',
  'column.leads.code',
  'column.leads.createdAt',
  'column.leads.effectiveFrom',
  'column.leads.policyCode',
  'column.leads.status',
  'column.members.activeFrom',
  'column.members.activeTo',
  'column.members.insuredPartnerName',
  'column.members.monthlyPremium',
  'column.members.objectIdentifier',
  'column.members.policyCode',
  'column.members.tarifVersionErn',
  'column.value',
  'field.billingFrequency',
  'field.billingMode',
  'field.code',
  'field.data',
  'field.groupTarifVersionErn',
  'field.partners',
  'field.policyholder',
  'field.status',
  'field.validFrom',
  'field.validTo',
  'sheet.leads',
  'sheet.members',
  'sheet.overview',
] as const;

export type GroupPolicyExportLabelKey = (typeof GROUP_POLICY_EXPORT_LABEL_KEYS)[number];

/** The `labels` map of the detail export, in the reader's language. */
export function buildGroupPolicyExportLabels(t: TFunction<'insurance'>): Record<string, string> {
  return Object.fromEntries(
    GROUP_POLICY_EXPORT_LABEL_KEYS.map((key) => [key, t(`exportLabels.groupPolicy.${key}`)]),
  );
}
